import React, { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';

import style from './shared-classes.module.less';
import { useDataExportFeatureGate } from '../../feature-gates/use-data-export-feature-gate';
import { FiltersContext } from '../../filters/context';
import { openExportShipmentsModal } from '../../store/export/shipments/export-shipments.actions';

/**
 * @returns {React.JSX.Element}
 */
export const ExportShipmentsButton = () => {
  const { buildApiFilters } = useContext(FiltersContext);
  const { isFeatureEnabled, disabledMessage } = useDataExportFeatureGate();
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(openExportShipmentsModal(buildApiFilters));
  }, [dispatch, buildApiFilters]);

  const disabledTooltipMessage = disabledMessage ? <FormattedMessage {...disabledMessage} /> : undefined;

  return (
    <Button
      className={style['action-button']}
      disabled={!isFeatureEnabled}
      disabledTooltipMessage={disabledTooltipMessage}
      onClick={onClick}
      theme='tertiary'
    >
      <FormattedMessage defaultMessage='Export Shipments' description='gridHeader.exportShipments' id='9Wvc7U' />
    </Button>
  );
};
